<template>
  <div>
    <b-form-group
      :label="label"
      :style="!label ? 'margin-bottom:0' : ''"
    >
      <v-select
        ref="statusSelect"
        v-model="value_"
        :options="status"
        label="nome"
        :class="{'is-select-invalid': invalido}"
        :multiple="multiple"
        :disabled="disabled"
        @close="onTouch"
        @open="carregarStatus"
        @search-change="carregarStatus"
        @input="enviarParaPai"
      />
    </b-form-group>
  </div>
</template>

<style lang="scss">
.is-select-invalid  .vs__dropdown-toggle {
  border-color: #ea5455 !important;
  background-repeat: no-repeat !important;
  background-size: calc(0.725em + 0.438rem) calc(0.725em + 0.438rem) !important;
}
</style>

<script>
import vSelect from 'vue-select'
import api from '@/app-modulo/comuns/departamentos/shared/services/api'
import '@core/scss/vue/libs/vue-select.scss'

export default {
  name: 'StatusSelect',
  components: {
    vSelect,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'Status',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    require: {
      type: Boolean,
      default: false,
    },
    invalido: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [Object, Array],
      default: () => { },
    },
    itensStatus: {
      type: [Array, Object],
      default: () => [{ tipo: 'aguardandohomologacao', nome: 'Aguardando homologação' },
        { tipo: 'homologado', nome: 'Homologado' },
        { tipo: 'pendente', nome: 'Pendente' },
        { tipo: 'recusado', nome: 'Recusado' },
        { tipo: 'dispensado', nome: 'Dispensado' }],
    },
  },
  data() {
    return {
      valueAttr: null,
      foiAcessado: false,
      status: [],
      statusPrimeiroAcesso: true,
      nomeStatus: '',
      depsCarregados: [],
    }
  },
  computed: {
    value_: {
      get() {
        return this.valueAttr ? this.valueAttr : this.value
      },
      set(newValue) {
        this.valueAttr = newValue
        return this.valueAttr
      },
    },
    isInvalid() {
      return this.invalid && this.foiAcessado
    },
  },
  watch: {
    value(val, oldVal) {
      if (val !== oldVal) {
        this.valueAttr = val
      }
    },
  },
  /* eslint no-underscore-dangle: 0 */
  methods: {
    carregarStatus(nomeStatus) {
      if (nomeStatus && nomeStatus !== '') {
        this.status = this.itensStatus.filter(fil => fil.nome.includes(nomeStatus))
      } else {
        this.status = [...this.itensStatus]
      }
    },
    carregarDepartamentosFiltrados(nomeDepartamento) {
      this.nomeDepartamento[0].value = nomeDepartamento

      api.getDepartamentosFiltrados(this.nomeDepartamento)
        .then(payload => {
          this.setItensCarregados(payload.data)
        })
        .catch(err => {
          this.$errorFormated(err.response)
          throw err
        })
    },
    propagarParaFilho() {
      this.$refs.departamentoSelect.focus()
    },
    enviarParaPai() {
      this.$emit('select', !this.value_ ? null : this.value_)
      this.$emit('input', !this.value_ ? null : this.value_)
    },
    onTouch() {
      this.foiAcessado = true
    },
    limpar() {
      this.value_ = []
    },
    filtrarDepsExternos(nome) {
      if (nome !== '') {
        this.departamentos = this.depsExternos.filter(fil => fil.nome === nome)
      } else {
        this.departamentos = this.depsExternos
      }
    },
    setItensCarregados(itensCarregados) {
      const itensFiltroAdicional = this.filtroAdicional(itensCarregados)
      this.departamentos = itensFiltroAdicional !== null ? itensFiltroAdicional : itensCarregados
    },
  },
}
</script>
